import React from 'react';
// import Footer from './Footer';
import { useNavigate } from "react-router-dom";
const EdgeComputingPage = () => {
  const navigate = useNavigate();
  return (
    <>
      <style>{`
        .page-hero-title {
          opacity: 0;
          transform: translateY(28px) scale(0.98);
          animation: pageHeroTitleReveal 1s ease-out forwards;
        }

        @keyframes pageHeroTitleReveal {
          0% {
            opacity: 0;
            transform: translateY(28px) scale(0.98);
            letter-spacing: 0.02em;
            filter: blur(8px);
          }
          60% {
            opacity: 1;
            transform: translateY(-4px) scale(1.01);
            filter: blur(0);
          }
          100% {
            opacity: 1;
            transform: translateY(0) scale(1);
            letter-spacing: 0;
            filter: blur(0);
          }
        }
      `}</style>
      <div style={{ backgroundColor: '#fff', color: '#000' }}>
        <section className="section" style={{ maxWidth: 1200, margin: '0 auto', padding: '120px 20px' }}>
          
      {/* Back Button */}
       <div style={{ marginBottom: 30 }}>
        <p
       style={{
      display: "inline-block",
      cursor: "pointer",
      margin: 0,
      fontSize: 14,
      color: "#555555"
       }}
        onMouseEnter={(e) => (e.target.style.textDecoration = "underline")}
        onMouseLeave={(e) => (e.target.style.textDecoration = "none")}
        onClick={() => navigate("/", { state: { openMenu: true } })}
  >
        ← Back to Menu
       </p>
         </div>

          <h1 className="page-hero-title" style={{ marginBottom: 24, textAlign: 'left' }}>AI-Powered Data Center Solutions</h1>
          <p style={{ opacity: 0.85, lineHeight: 1.7, maxWidth: 900 }}>
            At the intersection of innovation and infrastructure, our AI-driven data center services deliver
            efficiency, resilience, and intelligence. We modernize your IT backbone with automation,
            predictive analytics, and real-time optimization—all in a black-and-white design language.
          </p>

          <div style={{ marginTop: 32 }}>
            <h2 style={{ textAlign: 'center', marginBottom: 16 }}>Our AI-Enhanced Data Center Services</h2>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: 16, marginTop: 12 }}>
              <div style={{ border: '1px solid #333', padding: 16 }}>
                <h3>Predictive Maintenance & Monitoring</h3>
                <p>Anticipate failures using anomaly detection on sensor data.</p>
                <p style={{ opacity: 0.8 }}>Use Case: Outages reduced by 40% with our predictive models.</p>
              </div>
              <div style={{ border: '1px solid #333', padding: 16 }}>
                <h3>Intelligent Energy Optimization</h3>
                <p>Adaptive control of cooling and power to cut energy costs and emissions.</p>
                <p style={{ opacity: 0.8 }}>Use Case: 15% energy reduction in a Tier IV data center.</p>
              </div>
              <div style={{ border: '1px solid #333', padding: 16 }}>
                <h3>Autonomous Resource Management</h3>
                <p>AI orchestrates compute, storage, and network for superior utilization.</p>
                <p style={{ opacity: 0.8 }}>Use Case: 30% server utilization improvement.</p>
              </div>
              <div style={{ border: '1px solid #333', padding: 16 }}>
                <h3>AI-Driven Security & Threat Detection</h3>
                <p>Real-time monitoring of traffic and behavior for proactive defense.</p>
                <p style={{ opacity: 0.8 }}>Use Case: Prevented a major breach with anomaly detection.</p>
              </div>
              <div style={{ border: '1px solid #333', padding: 16 }}>
                <h3>Capacity Forecasting & Planning</h3>
                <p>Forecast future demand to scale smartly and avoid over-provisioning.</p>
                <p style={{ opacity: 0.8 }}>Use Case: Saved $1.2M via 12-month capacity insights.</p>
              </div>
            </div>
          </div>

          <div style={{ marginTop: 32 }}>
            <h2 style={{ textAlign: 'center', marginBottom: 16 }}>Why Choose Us</h2>
            <ul style={{ listStyle: 'disc', paddingLeft: 20, lineHeight: 1.8 }}>
              <li>Enterprise-grade AI models and engineering</li>
              <li>24/7 intelligent monitoring and telemetry</li>
              <li>Custom integrations with existing infrastructure</li>
              <li>Sustainability-focused designs and operations</li>
              <li>Proven ROI across industries</li>
            </ul>
          </div>
        </section>
      </div>
      {/* <Footer /> */}
    </>
  );
};

export default EdgeComputingPage;


